import { Pipe, PipeTransform } from '@angular/core';
import { CountryService } from '../providers/country.service';

@Pipe({
    name: 'roblexCountry',
})
export class CountryPipe implements PipeTransform {
    /**
     * Creates an instance of country pipe.
     * @param stateConfig StateConfig
     */
    constructor(private countryService: CountryService) {}
    /**
     * Transforms country pipe
     * @param value string
     * @returns string
     */
    transform(value: string): string {
        const country = this.countryService.getById(value);
        return country ? country?.name : value;
    }
}
